<template>
  <el-switch
    v-model="value"
    active-color="#3fdbbf"
    inactive-color="#989aae"
    @change="onChange"
  >
  </el-switch>
</template>

<script>
export default {
  name: "SwitchTax",
  data() {
    return {
      value: this.setValue,
      codigo: this.setStatusId
    };
  },
  methods: {
    onChange() {
      this.$emit("onChange", { value: this.value, codigo: this.codigo });
    }
  },
  watch: {
    setValue(val) {
      this.value = this.$options.filters.formatBoolean(val);
    }
  },
  props: {
    setValue: {
      default: false
    },
    setStatusId: {
      default: null
    }
  },
  mounted() {
    this.value = this.$options.filters.formatBoolean(this.setValue);
  }
};
</script>

<style></style>
